.rich-textarea-email {
    padding: 32px;
}
